import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo.svg';
import frameIcon from '../assets/icons/Frame.svg';
import { useSelector } from 'react-redux';

export default function MedicalQuestionnaireHeader() {
  const navigate = useNavigate();
  const userRole = useSelector((s) => s.user.role);
  const viewAsRole = useSelector((s) => s.user.viewAsRole);
  const userOrganization = useSelector((s) => s.user.organization);
  const isSupervisor = userRole === 'Supervisor';
  const isPatientView = isSupervisor ? viewAsRole !== 'Doctor/Nurse' : false;
  const logoSrc =
    isSupervisor && isPatientView
      ? logo
      : userOrganization === 'Qualevita'
        ? 'https://member.biowell.nl/QV_logo_H.webp'
        : userOrganization === 'Life Code Solutions'
          ? 'https://member.biowell.nl/LCS_logo.png'
          : logo;
  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-40 pt-4 pb-6 md:py-4">
      <div className="mx-auto w-full max-w-[1920px] px-4 sm:px-6 md:px-10 lg:px-16 xl:px-24 2xl:px-40">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center space-x-3">
            <Link to="/" className="flex items-center space-x-3" aria-label="Go to home">
              <img
                src={logoSrc}
                alt={`${logoSrc === logo ? 'BIOWELL' : (userOrganization || 'BIOWELL')} Logo`}
                className={
                  logoSrc === logo
                    ? 'h-10 w-auto sm:h-12'
                    : userOrganization === 'Qualevita'
                      ? 'h-14 w-auto sm:h-16'
                      : 'h-10 w-auto sm:h-12'
                }
              />
            </Link>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <span className="opacity-0 pointer-events-none">My Profile</span>
            <span className="opacity-0 pointer-events-none">Your Advice</span>
            <span className="opacity-0 pointer-events-none">Test History</span>
          </nav>

          <div className="flex items-center space-x-3 sm:space-x-4">
            <div className="hidden md:flex items-center space-x-2 sm:space-x-3 rounded-full bg-[#F7F7F7] pl-3 sm:pl-6 pr-2 py-1">
              <button
                type="button"
                onClick={() => navigate('/your-advice')}
                className="h-8 sm:h-12 px-4 sm:px-5 rounded-full bg-[#F7F7F7] text-black text-xs sm:text-sm font-poppins font-medium transition-colors inline-flex items-center gap-2"
              >
                Opslaan en afsluiten
                <img src={frameIcon} alt="" aria-hidden="true" className="w-3.5 h-3.5" />
              </button>
            </div>

            <button
              type="button"
              onClick={() => navigate('/your-advice')}
              className="md:hidden h-8 sm:h-12 px-4 sm:px-5 rounded-full bg-[#F7F7F7] text-black text-xs sm:text-sm font-poppins font-medium transition-colors inline-flex items-center gap-2"
            >
              Opslaan en afsluiten
              <img src={frameIcon} alt="" aria-hidden="true" className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
